import React from 'react';
import { Stack, Typography, Grid2, Button } from '@mui/material';
import { RenderMenuList } from '../features/student/Sidebar';
import { useDialog } from '../shared/hook/useDialog';
import MainDialogBox from '../shared/components/Dialog/MainDialogBox';
import { Field, Form, Formik } from 'formik'
import * as Yup from 'yup'
import { useMutation } from '@tanstack/react-query';
import useAuthStore from '../store/useAuthStore';
// import api from '../assets/api/useStudentPostApi';
import { TextFormField } from '../shared/components/formfields/TextFormField';
import { useToaster } from '../shared/utils/ToasterProvider';
import { Grid_Gap } from '../shared/constants';
import CustomDivider from '../shared/utils/CustomDivider';
import api from '../assets/nodeApi/axiosInstance';

const SidebarMenuWithChangePassword = ({ menuList }) => {
    const { open, handleClickOpen, handleClose } = useDialog();
    const { user, token } = useAuthStore()
    const { showToaster } = useToaster();
    const mutation = useMutation({
        mutationFn: (formData) => {
            const endpoint =
                user?.role === 'organizer'
                    ? 'change-organiser-password'
                    : 'change-password';

            return api.post(endpoint, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
        },
        onSuccess: (response) => {
            showToaster('Success', response?.data?.message, 'success');
        },
        onError: (error) => {
            if (error?.response?.status === 400) {
                showToaster(error.response.data.message, 'Error', 'error');
            } else {
                showToaster('Error Caught While submitting the form', 'Error', 'error');
            }
        },
    });

    const handleSubmit = (values, { setSubmitting, resetForm }) => {
        const payload = {
            ...values,
            ...(user?.role === 'organizer' && { email: user.email }),
        };
        mutation.mutate(payload, {
            onSettled: () => {
                setSubmitting(false);
            },
            onSuccess: () => {
                resetForm();
                handleClose();
            }
        });
    }
    return (
        <>
            <Stack spacing={2}>
                <RenderMenuList menuList={menuList} />
                <CustomDivider size={"0.5rem"} />
                {
                    user?.role !== 'Admin' &&
                    <>
                        <Typography
                            variant="body2"
                            textAlign="center"
                            fontSize="0.8rem"
                            sx={{ cursor: 'pointer' }}
                            onClick={handleClickOpen}
                        >
                            Change Password
                        </Typography>
                        <CustomDivider size={"2rem"} />
                    </>
                }

            </Stack>

            <MainDialogBox open={open} handleClose={handleClose} width={"40%"}>
                <Formik
                    initialValues={{
                        old_password: "",
                        new_password: "",
                        new_password_confirmation: ""
                    }}
                    enableReinitialize={true}
                    validationSchema={
                        Yup.object().shape({
                            old_password: Yup.string().required('Old Password is required'),
                            new_password: Yup
                                .string()
                                .min(8, "Password must be at least 8 characters")
                                .max(16, "Password must be at most 16 characters")
                                .required("Password is required"),

                            new_password_confirmation: Yup
                                .string()
                                .oneOf([Yup.ref("new_password"), null], "Passwords must match")
                                .required("Confirm Password is required"),
                        })
                    }
                    onSubmit={handleSubmit}
                >
                    {() => (
                        <Form>
                            <Grid2 container spacing={Grid_Gap}>
                                <Grid2 children size={12}>
                                    <Field
                                        name="old_password"
                                        component={TextFormField}
                                        label="Old Password"
                                        isRequired={true}
                                        type="password"
                                    />
                                </Grid2>

                                <Grid2 children size={12}>
                                    <Field
                                        name="new_password"
                                        component={TextFormField}
                                        label="New Password"
                                        isRequired={true}
                                        type="password"
                                    />
                                </Grid2>
                                <Grid2 children size={12}>
                                    <Field
                                        name="new_password_confirmation"
                                        component={TextFormField}
                                        label="Confirm Password"
                                        isRequired={true}
                                        type="password"

                                    />
                                </Grid2>
                                <Grid2 children textAlign={"end"} size={12}>
                                    <Button variant='contained' type='submit' fullWidth>Submit</Button>
                                </Grid2>
                            </Grid2>
                        </Form>
                    )}
                </Formik>
            </MainDialogBox>
        </>
    );
};

export default SidebarMenuWithChangePassword;
